import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/api";

const PAGE_MESSAGES = {
  "/": "Hi Hi-Tech Realty, I want to know more about Property Management & Monitoring services in Chennai.",
  "/nri-corner": "Hi, I want to secure and manage my property in Chennai while I am abroad.",
  "/services/senior-citizen": "Hi, I need trusted local help for managing my home, tenant, maintenance, or property documents.",
  "/services/plot-monitoring": "Hi, I want regular monitoring for my vacant plot in Chennai to prevent encroachment.",
  "/services/rental-management": "Hi, I need help finding tenants, collecting rent, and managing my rental property in Chennai.",
  "/pricing": "Hi, I want help choosing the right property management plan for my property in Chennai.",
  "/properties": "Hi, I am interested in a rental/sale property listed on your website.",
};

export default function WhatsAppWidget() {
  const [visible, setVisible] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 1200);
    return () => clearTimeout(t);
  }, []);

  const msg = PAGE_MESSAGES[location.pathname] || PAGE_MESSAGES["/"];

  if (!visible) return null;

  return (
    <a
      data-testid="floating-whatsapp"
      href={waLink(msg)}
      target="_blank"
      rel="noreferrer"
      className="fixed z-40 bottom-24 md:bottom-6 right-5 group flex items-center gap-3 bg-[#25D366] hover:bg-[#1FB956] text-white pl-3 pr-4 py-3 shadow-lg transition-all hover:-translate-y-0.5"
      aria-label="Chat with Chennai Property Manager"
    >
      <span className="w-9 h-9 grid place-items-center rounded-full bg-white/20">
        <MessageCircle size={20} />
      </span>
      <span className="hidden group-hover:inline text-xs font-semibold uppercase tracking-[0.18em]">
        Talk to Chennai Property Manager
      </span>
    </a>
  );
}
